module.exports = __webpack_public_path__ + "static/eventlisteners-9d4ce3a872c06b94293313ecb3df3bbc.png";